import { EventEmitter, OnDestroy } from "@angular/core";
import { LocalStorageProperties } from "../../globaldependencies/constants/localstorage-properties";
import { HubConnectionState } from "../models/hub-connection-state-enum";
import { UserRealTimeData } from "../models/user-real-time-data.model";
import * as _ from 'underscore';
import Dictionary from "../dictionary/dictionary";
import { s } from "@angular/core/src/render3";
import { Guid } from "guid-typescript";
import { AdminSettingsUpdateModel } from "../models/admin-settings-update-model";
import { UserRealTimeLocationData } from "../models/user-real-time-location";
import { TaskTimerInputModel } from "../models/task-timer-data.model";

declare var $_tracker: any;

export class RealTimeSignalRHub implements OnDestroy {

    public userStateChanged = new EventEmitter<UserRealTimeData>();
    public userLocationChanged = new EventEmitter<UserRealTimeLocationData>();
    public signalRconnectionInProgress = new EventEmitter<boolean>();
    public signalRHubConnectionError = new EventEmitter<boolean>();
    public officeTvFilter = new EventEmitter<any>();
    public autoUserCreatedDetection = new EventEmitter<UserRealTimeData>();
    public adminSettingsChanged = new EventEmitter<AdminSettingsUpdateModel>();
    public getRunningRecord = new EventEmitter<TaskTimerInputModel>();
    public testAutomationChanged = new EventEmitter<any>(); 
    referenceIdsForTestAutomation: string[] = [];

    hubConnection: any = null;
    loggedInUserId: string;
    companyId: string;
    connectionInProgress: boolean = false;
    canViewLiveStatus: boolean = false;
    newIdsToPushWhenConnected: boolean = false;
    trackerHub: any = null;
    retryConnecting: number = 0;
    environment = JSON.parse(localStorage.getItem(LocalStorageProperties.Environment));
    apiURL = (JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) != undefined && JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) != null) ? JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) : this.environment.apiURL;
    allreferenceIds: string[] = [];
    referenceIdsForLocation: string[] = [];
    referenceIdsForUserConfiguration: string[] = [];
    randomId: string;
    referenceIdForTaskTimer: string[] = [];

    userRealTimeStatusDictionary = new Dictionary<UserRealTimeData>();
    userRealTimeLocationDictionary = new Dictionary<UserRealTimeLocationData>();

    public constructor() {
        this.userRealTimeStatusDictionary = new Dictionary<UserRealTimeData>();
        this.allreferenceIds = [];
        this.randomId = Guid.create().toString();
    }

    async establishConnectionWithRealTimeHub() {
        console.log("[SIGNALR] establishConnectionWithRealTimeHub called!");
        while (true) {

            if (localStorage.getItem(LocalStorageProperties.IsSignalREnabled) != null &&
                localStorage.getItem(LocalStorageProperties.IsSignalREnabled) != undefined
            ) {
                this.canViewLiveStatus = localStorage.getItem(LocalStorageProperties.IsSignalREnabled) == 'true' ? true : false;
            } else {
                this.canViewLiveStatus = false;
            }
            if (JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) != undefined && JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) != null) {
                this.apiURL = JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath));
                console.log("[SIGNALR] Setting API URL: " + this.apiURL);
            }

            if (this.canViewLiveStatus) {
                //we don't want to force the connection here at all. It is basically dropping and reconnecting every 60 seconds.
                this.checkConnectionWithActivityTrackerHub(false);
            } else {
                console.log("live status feature was disabled");
                this.clearRealTimeStatusDictionary();
                this.disconnect();
            }
            await this.delay(60000);
        }
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    checkConnectionWithActivityTrackerHub(isForceIntialize) {
        if (isForceIntialize || this.retryConnecting > 3 ||
            (this.connectionInProgress == false &&
                (this.hubConnection == null || this.hubConnection == undefined ||
                    this.hubConnection.state == HubConnectionState.Disconnected
                ))) {
            this.retryConnecting = 0;
            this.establishSignalrConnection();
        } else if (this.hubConnection.state == HubConnectionState.Reconnecting || this.hubConnection.state == HubConnectionState.Connecting) {
            console.log("connection is in connecting state on retry " + this.retryConnecting)
            this.retryConnecting = this.retryConnecting + 1;
        } else {
            this.retryConnecting = 0;
            console.log("stable connection already exist");
        }
    }

    private establishSignalrConnection() {
        var self = this;

        if (self.connectionInProgress != true) {
            self.connectionInProgress = true;
            self.signalRconnectionInProgress.next(true);
            self.signalRHubConnectionError.next(false);
            var clientWebUserId = this.loggedInUserId + "-" + this.randomId + "-web-main";
            var companyId = this.companyId;


            if (self.hubConnection) {
                //Take this path if there is already a hub. Although why would we if we are connected already???
                //are we indeed connected
                if (!this.isSignalRConnected()) {
                    console.log("restarting the already existing connection 1");
                    self.hubConnection.start().done(function () {
                        /*
                        self.trackerHub.invoke("UpdateClientCredData", JSON.stringify({ ClientUserId: clientWebUserId, CompanyId: companyId }));
                        console.log('UpdateClientCredData :', JSON.stringify({ ClientUserId: clientWebUserId, CompanyId: companyId }));
                        self.connectionInProgress = false;
                        self.signalRconnectionInProgress.next(false);
                        self.signalRHubConnectionError.next(false);
                        console.log("connectionEstablished");
                        self.invokeStatusChanges();
                        */
                        console.log("[SIGNALR] hubConnection.Start().Done - hub already existed")
                    }).fail(function () {
                        self.connectionInProgress = false;
                        self.signalRconnectionInProgress.next(false);
                        self.signalRHubConnectionError.next(true);
                        console.log("connection failed");
                    });
                } else {
                    console.log("[SIGNALR] establishSignalrConnection already connected so doing nothing");
                }
                return;
            }

            console.log("[SIGNALR] no available hub so creating and connecting");

            self.hubConnection = $_tracker.hubConnection(self.apiURL + 'signalr', { useDefaultPath: false });

            self.hubConnection.stateChanged((state) => {
                //What is the point of this??
                const newState = self.getConnectionState(state);
                if (newState == HubConnectionState.Connected) {
                    console.log('SIGNALR] (On)stateChange(Connected) called UpdateClientCredData  with :', JSON.stringify({ ClientUserId: clientWebUserId, CompanyId: companyId }));
                    self.trackerHub.invoke("UpdateClientCredData", JSON.stringify({ ClientUserId: clientWebUserId, CompanyId: companyId }));
                    self.connectionInProgress = false;
                    self.signalRconnectionInProgress.next(false);
                    self.signalRHubConnectionError.next(false);
                    self.invokeStatusChanges();
                    self.subScribeForRecordChanges([this.loggedInUserId]);
                    self.getTestAutomationForUsers([this.loggedInUserId]);
                }
            });

            self.trackerHub = self.hubConnection.createHubProxy('ActivityTrackerHub');

            self.trackerHub.on('autoUserCreationDetectedFromTracker', function (userRealTimeData: UserRealTimeData) {
                self.autoUserCreatedDetection.next(userRealTimeData);
            });

            self.trackerHub.on('testAutomation', function(data : any){
                self.testAutomationChanged.next(data);
                console.log(data,"testautomationdatastatus");
            })
            
            self.trackerHub.on('statusChangeNotified', function (userRealTimeData: UserRealTimeData) {
                if (userRealTimeData.DesktopDeviceId == null) {
                    console.log(`[SIGNALR] [ERROR] (on)statusChangeNotified - UserRealTimeData has NULL DesktopID. Not updating state! UserID: ${userRealTimeData.UserId} DesktopID: ${userRealTimeData.DesktopDeviceId} Status: ${userRealTimeData.CurrentStatusEnum}`);
                } else {
                    //console.log(`[SIGNALR] (on)statusChangeNotified - UserRealTimeData. UserID: ${userRealTimeData.UserId} DesktopID: ${userRealTimeData.DesktopDeviceId} Status: ${userRealTimeData.CurrentStatusEnum}`);                        
                    self.saveInDictionaryForFurtherUse(userRealTimeData);
                    self.userStateChanged.next(userRealTimeData);
                }
            });
            self.trackerHub.on('someThingWentWrong', function (exceptionMessage) {
                console.log(exceptionMessage);
            });
            self.trackerHub.on('getUserLiveLocation', function (userRealTimeLocationData: UserRealTimeLocationData) {
                if (userRealTimeLocationData.UserId == null) {
                    console.log(`[SIGNALR] [ERROR] (on)getUserLiveLocation - UserRealTimeLocationData has NULL DesktopID. Not updating state! UserID: ${userRealTimeLocationData.UserId} DesktopID: ${userRealTimeLocationData.MobileDeviceId} Status: ${userRealTimeLocationData.Latitude}`);
                }
                else {
                    self.saveUserLocationInDictionaryForFurtherUse(userRealTimeLocationData);
                    self.userLocationChanged.next(userRealTimeLocationData);
                }
            });
            self.trackerHub.on('getRunningRecordDetails', function (recordDetails: any) {
                if (recordDetails.UserId == null) {
                    console.log(`[SIGNALR] [ERROR] (on)getRunningRecordDetails has NULL UserId. Not updating state! UserID: ${recordDetails.UserId}`);
                }
                else {
                    self.getRunningRecord.next(recordDetails);
                }
            });
            self.hubConnection.start().done(function () {
                console.log("[SIGNALR] connectionEstablished.hubConnection.start() on hubConnection Done - Actual status is " + self.hubConnection.state);
            }).fail(function () {
                self.connectionInProgress = false;
                self.signalRconnectionInProgress.next(false);
                self.signalRHubConnectionError.next(true);
                console.log("connection failed");
            });

        }
        else {
            console.log("[SIGNALR] establishSignalrConnection skipped as connectionInProgress = true");
        }
    }

    private getConnectionState(state): HubConnectionState {
        console.log('HubConnectionState changed from ' + state.oldState + ' to ' + state.newState);
        switch (state.newState) {
            case HubConnectionState['Connecting']:
                return HubConnectionState.Connecting;
            case HubConnectionState['Connected']:
                return HubConnectionState.Connected;
            case HubConnectionState['Reconnecting']:
                return HubConnectionState.Reconnecting;
            case HubConnectionState['Disconnected']:
                return HubConnectionState.Disconnected;
            default:
                return HubConnectionState.Connecting;
        }
    }

    private isSignalRConnected(): boolean {
        return this.hubConnection != null && this.hubConnection.state == HubConnectionState.Connected;
    }

    public ngOnDestroy(): void {
        this.userStateChanged.complete();
        this.signalRconnectionInProgress.complete();
        this.signalRHubConnectionError.complete();
        this.officeTvFilter.complete();
        this.autoUserCreatedDetection.complete();
        this.adminSettingsChanged.complete();
        this.testAutomationChanged.complete();
        this.clearRealTimeStatusDictionary();
        this.disconnect();
    }

    public clearRealTimeStatusDictionary() {
        this.userRealTimeStatusDictionary = new Dictionary<UserRealTimeData>();
        this.allreferenceIds = [];
    }

    private disconnect(): void {
        if (this.hubConnection) {
            if (this.hubConnection.state === HubConnectionState.Disconnected) {
                return;
            }
            try {
                this.hubConnection.stop(true, true);
            } catch (e) {
                console.log(e);
                return;
            }
        }
    }

    saveInDictionaryForFurtherUse(realTimeData: UserRealTimeData) {
        if (realTimeData && realTimeData.DesktopDeviceId) {
            console.log("saving " + realTimeData.DesktopDeviceId + " into dictionary for further use");
            this.userRealTimeStatusDictionary.add(realTimeData.DesktopDeviceId, realTimeData);
        }
    }
    saveUserLocationInDictionaryForFurtherUse(userRealTimeLocationData: UserRealTimeLocationData) {
        if (userRealTimeLocationData && userRealTimeLocationData.UserId) {
            console.log("saving " + userRealTimeLocationData.UserId + " into dictionary for further use");
            this.userRealTimeLocationDictionary.add(userRealTimeLocationData.UserId, userRealTimeLocationData);
        }
    }
    public getCurrentUserStatusFromDictionary(referenceId: string) {
        return this.userRealTimeStatusDictionary.getItem(referenceId);
    }

    public getStatusChangesForUsers(referenceIds: string[]) {
        let isnewReferenceIdAdded = false;
        referenceIds.forEach(referenceId => {
            if (referenceId != null && referenceId != '' && this.checkIfValidGUID(referenceId) && this.allreferenceIds.findIndex(p => p == referenceId) == -1 && this.userRealTimeStatusDictionary.getItem(referenceId) == null) {
                this.allreferenceIds.push(referenceId);
                isnewReferenceIdAdded = true;
            }
            if (this.userRealTimeStatusDictionary.getItem(referenceId)) {
                //console.log("triggering live status from dictionary");
                this.userStateChanged.next(this.userRealTimeStatusDictionary.getItem(referenceId));
            }
        });
        if (this.canViewLiveStatus && isnewReferenceIdAdded) {
            //console.log("Triggering invoke as new reference ids were added. Trying InvokeStatusChanges");
            //Let's flag the fact we have IDs to push.            
            this.newIdsToPushWhenConnected = true;
            this.invokeStatusChanges(referenceIds);
        }
    }

    public invokeStatusChanges(referenceIds?: string[]) {
        var self = this;
        var filterStatus = "Active";
        if (this.isSignalRConnected() && this.newIdsToPushWhenConnected) {
            if (this.allreferenceIds.length > 0) {
                try {
                    var referencesdata = this.allreferenceIds.join(';');
                    if (referenceIds != null) {
                        referencesdata = referenceIds.join(';');
                    }
                    // let siteAddress = this.apiURL;
                    // siteAddress = siteAddress.replace('https://','').replace('http://','');
                    // let siteAddressSplits = siteAddress.split('/');

                    console.log("referenceIds - " + referencesdata);
                    this.trackerHub.invoke("GetMeStatusChangesForUsers", referencesdata, self.companyId).done(function () {
                        console.log("sent GetMeStatusChangesForUsers request with userIds and siteaddress- " + referencesdata + "companyId" + self.companyId);
                        this.newIdsToPushWhenConnected = false;
                    }).fail(function () {
                        //ooh - something went wrong, wait for next go round status loop
                        console.log("GetMeStatusChangesForUsers request failed");
                    });
                } catch (e) {
                    console.log(e);
                    return;
                }
            }
        } else {
            console.log("[SIGNALR] invokeStatusChange skipped as not connected");
        }
    }

    public initialise() {
        console.log("[SIGNALR] Initalise Called");
        this.userStateChanged = new EventEmitter<UserRealTimeData>();
        this.officeTvFilter = new EventEmitter<any>();
        this.autoUserCreatedDetection = new EventEmitter<UserRealTimeData>();
        this.adminSettingsChanged = new EventEmitter<AdminSettingsUpdateModel>();
        this.loggedInUserId = JSON.parse(localStorage.getItem(LocalStorageProperties.UserModel)).id;
        this.companyId = JSON.parse(localStorage.getItem(LocalStorageProperties.UserModel)).companyId;
        this.environment = JSON.parse(localStorage.getItem(LocalStorageProperties.Environment));
        this.connectionInProgress = false;
        this.canViewLiveStatus = false;
        this.retryConnecting = 0;
        this.allreferenceIds = [];
        var apiURL = (JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) != undefined && JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) != null) ? JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) : this.environment.apiURL;
        if (apiURL != this.apiURL) {
            this.restartSignalRConnection();
        }
        else {
            this.establishConnectionWithRealTimeHub();
        }
        console.log("[SIGNALR] Initalise Finished");
    }

    public restartSignalRConnection() {
        this.hubConnection = null;
        this.trackerHub = null;
        this.apiURL = (JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) != undefined && JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) != null) ? JSON.parse(localStorage.getItem(LocalStorageProperties.SignalRBasePath)) : this.environment.apiURL;
        this.userRealTimeStatusDictionary = new Dictionary<UserRealTimeData>();
        this.userRealTimeLocationDictionary = new Dictionary<UserRealTimeLocationData>();
        this.establishConnectionWithRealTimeHub();
    }

    private checkIfValidGUID(str) {
        // Regular expression to check if string is a valid GUID
        const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

        return regexExp.test(str);
    }

    public getUserIdsFromOfficeTvFilters(filterStatus: string) {
        var self = this;
        // if (!this.isSignalRConnected()){
        {
            console.log("restarting the already existing connection 1");
            self.hubConnection.start().done(function () {
                console.log("[SIGNALR] hubConnection.Start().Done - hub already existed");
                self.trackerHub.invoke("StatusFilterForOfficeTv", filterStatus, self.companyId).done(function (userIds) {
                    self.officeTvFilter.next(userIds);
                });
            }).fail(function () {
                self.connectionInProgress = false;
                self.signalRconnectionInProgress.next(false);
                self.signalRHubConnectionError.next(true);
                console.log("connection failed");
            });
        }
        // }
        // if (this.isSignalRConnected())
        // {
        //     self.trackerHub.invoke("StatusFilterForOfficeTv", filterStatus,self.companyId).done(function (userIds) {
        //         self.officeTvFilter.next(userIds);
        //     });
        // }
        /*
        if (self.hubConnection) {
            self.hubConnection.start().done(function () {
                self.trackerHub.invoke("StatusFilterForOfficeTv", filterStatus,self.companyId).done(function (userIds) {
                    self.officeTvFilter.next(userIds);
                });
            }).fail(function () {
                self.connectionInProgress = false;
                self.signalRconnectionInProgress.next(false);
                self.signalRHubConnectionError.next(true);
                console.log("connection failed");
            });
        }
        */
    }

    public getLocationChangeForUsers(referenceIds: string[]) {
        var isnewReferenceIdAdded = false;
        var hasLocationHistory = false;
        referenceIds.forEach(referenceId => {
            if (referenceId != null && referenceId != '' && this.checkIfValidGUID(referenceId) && this.referenceIdsForLocation.findIndex(p => p == referenceId) == -1 && this.userRealTimeLocationDictionary.getItem(referenceId) == null) {
                this.referenceIdsForLocation.push(referenceId);
                isnewReferenceIdAdded = true;
            }
            if (this.userRealTimeLocationDictionary.getItem(referenceId)) {
                //console.log("triggering live status from dictionary");
                this.userLocationChanged.next(this.userRealTimeLocationDictionary.getItem(referenceId));
                hasLocationHistory = true;
            }

        });
        if (isnewReferenceIdAdded || !hasLocationHistory) {
            //console.log("Triggering invoke as new reference ids were added. Trying InvokeStatusChanges");
            //Let's flag the fact we have IDs to push.            
            this.newIdsToPushWhenConnected = true;
            this.invokeLocationChanges(referenceIds);
           
        }
       
    }
    public invokeLocationChanges(referenceIds?: string[]) {
        var self = this;

        if (this.isSignalRConnected() && this.newIdsToPushWhenConnected) {
            if (this.referenceIdsForLocation.length > 0) {
                try {
                    var referencesdata;
                    if (referenceIds != null) {
                        referencesdata = referenceIds.join(';');
                    }
                    else {
                        referencesdata = this.referenceIdsForLocation.join(';');
                    }
                    console.log("referenceIds - " + referencesdata);
                    console.log("The Reference Id's Count", this.referenceIdsForLocation.length);
                    this.trackerHub.invoke("GetUserLiveLocation", referencesdata, self.companyId).done(function () {
                        console.log("sent GetUserLiveLocation request with userIds and siteaddress- " + referencesdata + "companyId" + self.companyId);
                        this.newIdsToPushWhenConnected = false;

                    }).fail(function () {
                        //ooh - something went wrong, wait for next go round status loop
                        console.log("GetUserLiveLocation request failed");
                    });
                } catch (e) {
                    console.log(e);
                    return;
                }

            }
        } else {
            console.log("[SIGNALR] invokeStatusChange skipped as not connected");
        }
    }

    public getTestAutomationForUsers(referenceIds: string[]) {
        let isnewReferenceIdAdded = false;
        referenceIds.forEach(referenceId => {
            if (referenceId != null && referenceId != '' && this.checkIfValidGUID(referenceId) && this.referenceIdsForTestAutomation.findIndex(p => p == referenceId) == -1) {
                this.referenceIdsForTestAutomation.push(referenceId);
                isnewReferenceIdAdded = true;
            }
        });
        if (isnewReferenceIdAdded) {
            this.newIdsToPushWhenConnected = true;
            this.invokeTestAutomationSubscription(referenceIds);
        }
    }

    public invokeTestAutomationSubscription(referenceIds?: string[]) {
        var self = this;
        if (this.isSignalRConnected() && this.newIdsToPushWhenConnected) {
            if (this.referenceIdsForTestAutomation.length > 0) {
                try {
                    var referencesdata;
                    if (referenceIds != null) {
                        referencesdata = referenceIds.join(';');
                    } else {
                        referencesdata = this.referenceIdsForTestAutomation.join(';');
                    }
                    console.log("TestAutomation referenceIds - " + referencesdata);
                    this.trackerHub.invoke("SubscribeToTestAutomation", referencesdata, self.companyId).done(function () {
                        console.log("sent SubscribeToTestAutomation request with userIds - " + referencesdata + " companyId " + self.companyId);
                        this.newIdsToPushWhenConnected = false;
                    }).fail(function () {
                        console.log("SubscribeToTestAutomation request failed");
                    });
                } catch (e) {
                    console.log(e);
                    return;
                }
            }
        } else {
            console.log("[SIGNALR] invokeTestAutomationSubscription skipped as not connected");
        }
    }


    public invokeTaskSelectionChanged(hubRequestData: any) {
        var self = this;

        if (this.isSignalRConnected()) {
            try {
                console.log("The Selected User Id : ", hubRequestData);
                this.trackerHub.invoke("TaskSelectionChanged", JSON.stringify(hubRequestData)).done(function () {
                    console.log("sent invokeTaskSelectionChanged request with required hub data" + JSON.stringify(hubRequestData));

                }).fail(function () {
                    console.log("invokeTaskSelectionChanged request failed");
                });
            } catch (e) {
                console.log(e);
                return;
            }
        } else {
            console.log("[SIGNALR] invokeTaskSelectionChanged skipped as not connected");
        }
    }

    public sendUserConfiguration(referenceIds: string[]) {
        var isnewReferenceIdAdded = false;
        referenceIds.forEach(referenceId => {
            if (referenceId != null && referenceId != '' && this.checkIfValidGUID(referenceId) && this.referenceIdsForLocation.findIndex(p => p == referenceId) == -1) {
                this.referenceIdsForUserConfiguration.push(referenceId);
                isnewReferenceIdAdded = true;

            }

        });
        if (isnewReferenceIdAdded) {
            //console.log("Triggering invoke as new reference ids were added. Trying InvokeStatusChanges");
            //Let's flag the fact we have IDs to push.            
            this.newIdsToPushWhenConnected = true;
            this.invokeUserConfiguration();
        }
    }
    public invokeUserConfiguration() {
        var self = this;

        if (this.isSignalRConnected() && this.newIdsToPushWhenConnected) {
            if (this.referenceIdsForUserConfiguration.length > 0) {
                try {
                    var referencesdata = this.referenceIdsForUserConfiguration.join(';');
                    console.log("referenceIds - " + referencesdata);
                    console.log("The Reference Id's Count", this.referenceIdsForUserConfiguration.length);
                    this.trackerHub.invoke("UpdateUserConfigurationInJobSite", referencesdata, self.companyId).done(function () {
                        console.log("sent UpdateUserConfigurationInJobSite request with userIds and siteaddress- " + referencesdata + "companyId" + self.companyId);
                        this.newIdsToPushWhenConnected = false;
                        this.referenceIdsForUserConfiguration = [];

                    }).fail(function () {
                        //ooh - something went wrong, wait for next go round status loop
                        console.log("UpdateUserConfigurationInJobSite request failed");
                    });
                } catch (e) {
                    console.log(e);
                    return;
                }

            }
        } else {
            console.log("[SIGNALR] invokeStatusChange skipped as not connected");
        }
    }
    public getRunningRecordData(referenceIds: string[]) {
        var isnewReferenceIdAdded = false;
        referenceIds.forEach(referenceId => {
            if (referenceId != null && referenceId != '' && this.checkIfValidGUID(referenceId) && this.referenceIdForTaskTimer.findIndex(p => p == referenceId) == -1) {
                referenceId = referenceId + "-signalr"
                this.referenceIdForTaskTimer.push(referenceId);
                isnewReferenceIdAdded = true;
            }
        });
        if (this.referenceIdForTaskTimer.length > 0) {         
            this.newIdsToPushWhenConnected = true;
            this.subScribeForRecordChanges(referenceIds);
        }
    }
    public invokeGetRunningRecordMethod(taskTimerInputModel) {
        var self = this;
        if (this.isSignalRConnected() && this.newIdsToPushWhenConnected) {
            if (taskTimerInputModel.UserId != null) {
                try {
                    var referencesdata = taskTimerInputModel.UserId ;
                    this.trackerHub.invoke("GetRunningRecordDetails", taskTimerInputModel).done(function () {
                        console.log("sent GetRunningRecordDetails request with userIds and siteaddress- " + referencesdata + "companyId" + self.companyId);
                        this.newIdsToPushWhenConnected = false;
                        this.referenceIdForTaskTimer = [];
                    }).fail(function () {
                        console.log("GetRunningRecordDetails request failed");
                    });
                } catch (e) {
                    console.log(e);
                    return;
                }
            }
        } else {
            console.log("[SIGNALR] invokeStatusChange skipped as not connected");
            this.RetryUntilConnectedToGetRunningRecordDetails(taskTimerInputModel);
        }
    }
    public subScribeForRecordChanges(referenceIds?: string[])
    {
        var self = this;
        if (this.isSignalRConnected() && this.newIdsToPushWhenConnected) {
            if (this.referenceIdForTaskTimer.length > 0) {
                try {
                    var referencesdata;
                    if (referenceIds != null) {
                        referencesdata = referenceIds.join(';');
                    }
                    else {
                        referencesdata = this.referenceIdForTaskTimer.join(';');
                    }
                    this.trackerHub.invoke("SubScribeForRecordChanges", referencesdata).done(function () {
                        console.log("sent SubScribeForRecordChanges request with userIds and siteaddress- " + referencesdata + "companyId" + self.companyId);
                        this.newIdsToPushWhenConnected = false;
                        this.referenceIdForTaskTimer = [];
                    }).fail(function () {
                        console.log("SubScribeForRecordChanges request failed");
                    });
                } catch (e) {
                    console.log(e);
                    return;
                }
            }
        } else {
            console.log("[SIGNALR] invokeStatusChange skipped as not connected");
        }
    }
    async RetryUntilConnectedToGetRunningRecordDetails(taskTimerInputModel) {
        const maxRetries = 10;  
        let retryCount = 0;
        let delay = 500; 
    
        while (retryCount < maxRetries) {
            if (this.isSignalRConnected()) {
                console.log("[SIGNALR] Connection established");
                this.invokeGetRunningRecordMethod(taskTimerInputModel);
                break;
            } else {
                console.log(`[SIGNALR] Waiting for connection... Attempt ${retryCount + 1}`);
                retryCount++;
                await this.delay(delay); 
                delay *= 2;  // Exponential backoff
            }
        }
    
        if (retryCount === maxRetries) {
            console.log("[SIGNALR] Max retries reached. Exiting...");
        }
    }
}
